<template>
    <el-dialog
        :title="getVerbose('user_prompt_change_password_title')"
        :visible.sync="show"
        :append-to-body="true"
        :close-on-click-modal="false"
        class="modal-password-security"
        @close="onClose"
    >

        <form-change-password
            v-if="user"
            ref="formChangePassword"
            :email="user.email"
            hideButton
            @success="onPasswordChangeSuccess"
            alignButton="right"
        ></form-change-password>

        <span slot="footer">
            <el-button @click="close">{{ getVerbose('user_prompt_change_password_button_cancel') }}</el-button>
            <el-button type="primary" @click="submitChangePasswordForm">{{ getVerbose('user_prompt_change_password_button_confirm') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import FormChangePassword from '../../auth/FormChangePassword.vue';
import { mapGetters } from 'vuex';
export default {

    components: {
        FormChangePassword
    },

    props: {

    },

    data (){
        return {
            show: false,
            user: null,
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose',
        ]),
    },

    mounted (){

    },

    methods: {
        onPasswordChangeSuccess ({response, email, password}){
            this.close();
        },
        open (user, action, confirmPassword){
            this.user = user;
            this.show = true;
        },
        close (){
            this.show = false;
        },
        onClose (){
            this.show = false;
            this.user = null;
        },
        submitChangePasswordForm(){
            this.$refs.formChangePassword.submitChangePasswordForm();
        }
    },
};
</script>

<style lang="scss">
.modal-password-security{
    .message{
        margin-top: 20px;
    }

    .password-error{
        color: #F56C6C;
        height: 15px;
    }
    .rule-error{
        color: #F56C6C;
    }
    .password-check{
        margin-top: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/user/modal-password-security.vue